<template>
	<UPageSection
		:id="`page-section-${copy.id}`"
		orientation="horizontal"
		reverse
		:ui="{
			root: 'first-of-type:mt-12 not-first-of-type:mt-16 lg:-my-16',
			container: 'gap-8',
			title: 'text-2xl text-highlighted',
			description: 'text-lg mt-2'
		}"
	>
		<template #title>
			<motion.p
				:while-in-view="{ opacity: 1 }"
				:initial="{ opacity: 0 }"
				:transition="{ duration: 0.6, delay: 0.3 }"
				:in-view-options="{ once: true }"
			>
				{{ copy.content.title }}
			</motion.p>
		</template>
		<template #description>
			<motion.p
				v-if="copy.content.description"
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.6, delay: 0.3 }"
				:in-view-options="{ once: true }"
				class="will-change-transform"
			>
				{{ copy.content.description }}
			</motion.p>
		</template>
		<Motion
			as-child
			:while-in-view="{ opacity: 1, scale: 1 }"
			:initial="{ opacity: 0, scale: 0.95 }"
			:transition="{ type: 'spring', bounce: 0.5, duration: 1.4, delay: 0.3 }"
			:in-view-options="{ once: true }"
		>
			<NuxtImg
				:src="image.url"
				sizes="300px"
				:alt="`installation-image-${copy.id}`"
				:width="image.width || 280"
				:height="image.height || 280"
				class="w-[70%] lg:w-full max-w-[300px] mx-auto lg:mx-0 lg:shrink-0 lg:order-2 lg:ml-auto"
			/>
		</Motion>
	</UPageSection>
</template>

<script setup lang="ts">
import type {
	SectionItem, SectionItemCopy
} from '@/types/components/section-item'
import {
	Motion, motion
} from 'motion-v'

const props = defineProps({
	copy: {
		type: Object as PropType<SectionItemCopy>,
		required: true
	},
	viewbox: {
		type: Object as PropType<SectionItem['viewbox']>,
		default: () => ({
			width: 405,
			height: 405
		})
	},
	image: {
		type: Object as PropType<SectionItem['image']>,
		default: () => ({
			url: '/home-content-aside-1.avif'
		})
	}
})

const {
	viewbox,
	image
} = toRefs(props)
</script>
